import { Folder, Quiz, QuizOrFolder } from '../types';
import { concatQuizAndFolders } from './concatQuizAndFolders';
import { findAllChildren } from './findAllChildren';
import { uniqueIdFactory } from './uniqueIds';

export function toQuizOrFolder(
  { id, ...response }: ReturnType<typeof concatQuizAndFolders>[number],
  _index: number,
  allResponses: ReturnType<typeof concatQuizAndFolders>
): QuizOrFolder {
  const uniqueId = uniqueIdFactory[response.type].toUniqueId(id);
  if (response.type === 'folder') {
    const { lastUpdated, ...folder } = response;
    return {
      ...folder,
      date: new Date(lastUpdated),
      uniqueId: uniqueId,
      id: id,
      children: findAllChildren({ items: allResponses, currentId: id }),
    } as Folder;
  } else if (response.type === 'quiz') {
    const { date, ...quiz } = response;
    return {
      ...quiz,
      date: new Date(date),
      id: id,
      uniqueId: uniqueId,
    } as Quiz;
  }
}
